import React from 'react';
import { Table, Empty } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { PackingMethodRow } from '../../../services/pw1315Api';

interface ResultTableProps {
  data: PackingMethodRow[];
  loading: boolean;
  queried: boolean;
  noData: boolean;
}

const ResultTable: React.FC<ResultTableProps> = ({ data, loading, queried, noData }) => {
  const columns: ColumnsType<PackingMethodRow> = [
    { title: '包裝方式代號', dataIndex: 'code', key: 'code', width: 120 },
    { title: '包裝方式名稱', dataIndex: 'name', key: 'name' },
  ];

  if (!queried) return null;
  if (noData) return <Empty description="查無此資料" style={{ marginTop: 40 }} />;

  return (
    <Table<PackingMethodRow>
      columns={columns}
      dataSource={data}
      rowKey="code"
      loading={loading}
      size="small"
      pagination={{ pageSize: 50, showSizeChanger: true, showTotal: (t) => `共 ${t} 筆` }}
    />
  );
};

export default ResultTable;
